import { render, staticRenderFns } from "./AuthHandler.vue?vue&type=template&id=0dc47976&"
import script from "./AuthHandler.vue?vue&type=script&lang=js&"
export * from "./AuthHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports